import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import SearchBar from '../SearchBar';

export interface DropdownProps {
  id?: string;
  className?: string;
  children?: React.ReactNode;
  isOpen?: boolean;
  hasSearchBar?: boolean;
  handleSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  searchPlaceholder?: string;
}

const Dropdown = React.forwardRef<HTMLDivElement, DropdownProps>(
  (props: DropdownProps, ref) => {
    const {
      id,
      children,
      className,
      isOpen = false,
      hasSearchBar,
      handleSearch,
      searchPlaceholder,
    } = props;

    const dropdownClass = classNames(
      'ui-dropdown',
      {
        'ui-dropdown-searchbar': hasSearchBar,
      },
      className
    );

    return (
      <>
        {isOpen &&
          ReactDOM.createPortal(
            <div id={id} className={dropdownClass} ref={ref}>
              {hasSearchBar && (
                <SearchBar
                  onChange={handleSearch}
                  placeholder={searchPlaceholder}
                />
              )}
              <span className="ui-dropdown-list">{children}</span>
            </div>,
            document.body
          )}
      </>
    );
  }
);

export default Dropdown;
